require('../scss/woocommerce.scss');

//Hide WC Product tabs if there's only one
var $items = jQuery('.tabs.wc-tabs li');
if ($items.length === 1) {
	jQuery('.wc-tabs').addClass('d-none');
};

//Replace the woo column classes that do nothing and screw up Bootstrap
// jQuery('.woocommerce .col-1').removeClass('col-1');
// jQuery('.woocommerce .col-2').removeClass('col-2');


//Accordion for woo sidebar
if (jQuery('.widget_product_categories').length) {
	jQuery('.widget_product_categories > h4').attr({ id: 'pcatTrigger' }).wrapInner('<a class="stretched-link open" role="button" data-toggle="collapse" data-target="#pcatTarget" aria-expanded="true" aria-controls="pcatTarget"></button>');

	jQuery('.widget_product_categories .product-categories').attr({ id: 'pcatTarget', 'data-parent': '#pcatTrigger' }).addClass('collapse show');

	jQuery('#pcatTarget').on('show.bs.collapse', function () {
		jQuery('#pcatTrigger').addClass('open');
	});
	jQuery('#pcatTarget').on('hide.bs.collapse', function () {
		jQuery('#pcatTrigger').removeClass('open');
	});
}

//Move Email icon next to pdf
if (jQuery('#p_share_email').length) {
	jQuery('.woocommerce-print-products.link-wrapper').append(jQuery('#p_share_email'));
}